<div class="registration-container">
  <div class="registration-content">
    <div class="registration-header">
      <h1>{{ titleText }}</h1>
      <p class="subtitle">{{ subtitleText }}</p>
    </div>

    <div *ngIf="success" class="success-message">
      <p>✓ {{ successText }}</p>
    </div>

    <div *ngIf="error && !success" class="error-message">
      <p>{{ error }}</p>
    </div>

    <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" *ngIf="!success">
      <div class="form-section">
        <h3>{{ personalInfoText }}</h3>
        
        <div class="form-group">
          <label for="email">{{ emailLabel }} <span class="required">{{ requiredText }}</span></label>
          <input 
            type="email" 
            id="email" 
            formControlName="email"
            [class.error]="registrationForm.get('email')?.invalid && registrationForm.get('email')?.touched"
            placeholder="example@mail.com"
          />
          <span class="error-text" *ngIf="getFieldError('email')">
            {{ getFieldError('email') }}
          </span>
        </div>

        <div class="form-group">
          <label for="fullName">{{ fullNameLabel }} <span class="required">{{ requiredText }}</span></label>
          <input 
            type="text" 
            id="fullName" 
            formControlName="fullName"
            [class.error]="registrationForm.get('fullName')?.invalid && registrationForm.get('fullName')?.touched"
            [placeholder]="fullNamePlaceholderText"
          />
          <span class="error-text" *ngIf="getFieldError('fullName')">
            {{ getFieldError('fullName') }}
          </span>
        </div>

        <div class="form-group">
          <label for="phone">{{ phoneLabel }}</label>
          <input 
            type="tel" 
            id="phone" 
            formControlName="phone"
            [class.error]="registrationForm.get('phone')?.invalid && registrationForm.get('phone')?.touched"
            placeholder="+7 700 123 4567"
          />
          <span class="error-text" *ngIf="getFieldError('phone')">
            {{ getFieldError('phone') }}
          </span>
        </div>
      </div>

      <div class="form-section">
        <h3>{{ passwordText }}</h3>
        
        <div class="form-group">
          <label for="password">{{ passwordLabel }} <span class="required">{{ requiredText }}</span></label>
          <input 
            type="password" 
            id="password" 
            formControlName="password"
            [class.error]="registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched"
            [placeholder]="passwordPlaceholderText"
          />
          <span class="error-text" *ngIf="getFieldError('password')">
            {{ getFieldError('password') }}
          </span>
        </div>

        <div class="form-group">
          <label for="confirmPassword">{{ confirmPasswordLabel }} <span class="required">{{ requiredText }}</span></label>
          <input 
            type="password" 
            id="confirmPassword" 
            formControlName="confirmPassword"
            [class.error]="registrationForm.get('confirmPassword')?.invalid && registrationForm.get('confirmPassword')?.touched"
            [placeholder]="confirmPasswordPlaceholderText"
          />
          <span class="error-text" *ngIf="getFieldError('confirmPassword')">
            {{ getFieldError('confirmPassword') }}
          </span>
        </div>
      </div>

      <app-legal-consent class="form-consent" [control]="registrationForm.get('acceptTerms')"></app-legal-consent>
      <app-legal-consent class="form-consent" mode="personal-data" [control]="registrationForm.get('acceptPersonalData')"></app-legal-consent>


      <div class="form-actions">
        <button 
          type="submit" 
          class="submit-button"
          [disabled]="loading || registrationForm.invalid"
        >
          <span *ngIf="!loading">{{ submitText }}</span>
          <span *ngIf="loading">{{ submittingText }}</span>
        </button>
        
        <a routerLink="/login" class="login-link">
          {{ hasAccountText }}
        </a>
      </div>
    </form>
  </div>
</div>
